import { isObject } from 'lodash';
import { ShortCodeService } from '@ht/lib-plural-vue';

export function getDynamicObjects(data) {
  return Array.isArray(data)
    ? data.map((item) => getDynamicObjects(item))
    : Object.entries(data).reduce((acc, [key, value]) => {
      if (typeof value === 'string') {
        acc[key] = new ShortCodeService(value || '').matchAttributes().getValue();
      } else if (isObject(value)) {
        acc[key] = getDynamicObjects(value);
      } else {
        acc[key] = value;
      }
      return acc;
    }, {});
}
